import { createReducer } from "state/utils";
import * as actions from "state/action-types";
import { combineReducers } from "redux";

const selected = createReducer([], {
  [actions.SET_SELECTED_LOCATIONS_FILTER]: (_, action) => {
    return action.payload.selected;
  },
});

const options = createReducer([], {
  [actions.SET_LOCATIONS_FILTER_OPTIONS]: (_, action) => {
    return action.payload.options;
  },
});

export default combineReducers({
  selected,
  options,
});
